import React from 'react';
import PropTypes from 'prop-types';

import {
  Grid,
  GridCell,
} from 'components/LayoutGrid';

import PlaceholderCard from './PlaceholderCard';

const PlaceholderCardList = () => (
  <Grid>
    <GridCell span={{ desktop: 4, tablet: 6, mobile: 12 }} >
      <PlaceholderCard />
    </GridCell>
    <GridCell span={{ desktop: 4, tablet: 6, mobile: 12 }} >
      <PlaceholderCard />
    </GridCell>
    <GridCell span={{ desktop: 4, tablet: 6, mobile: 12 }} >
      <PlaceholderCard />
    </GridCell>
    <GridCell span={{ desktop: 4, tablet: 6, mobile: 12 }} >
      <PlaceholderCard />
    </GridCell>
    <GridCell span={{ desktop: 4, tablet: 6, mobile: 12 }} >
      <PlaceholderCard />
    </GridCell>
    <GridCell span={{ desktop: 4, tablet: 6, mobile: 12 }} >
      <PlaceholderCard />
    </GridCell>
  </Grid>
);

PlaceholderCardList.propTypes = {
  name: PropTypes.string,
  createdAt: PropTypes.string,
};

export default PlaceholderCardList;
